export type VonageConfigurationDTOV1 = {
  id?: UUID
  applicationName: string
  applicationId: string
  apiKey: string
  apiUrl: string
  privateKey: string
  signatureSecret: string
  smsNumbers?: VonageSmsNumber[]
  whatsappNumbers?: VonageWhatsAppNumber[]
}

export type VonageSmsNumber = {
  id?: number
  name: string
  number: string
  space?: UUID
  notification: boolean
  conversational: boolean
  rcs: boolean
  defaultSkill?: string
  requiredSkills: number[]
  vonageConfiguration?: VonageConfigurationDTOV1
}

export type VonageWhatsAppNumber = {
  id?: number
  active?: boolean
  name: string
  number: string
  wabaId: string
  nameSpace: string
  space: UUID
  defaultSkill?: string
  vonageConfiguration?: VonageConfigurationDTOV1
}

export type VonageConfigurationDTOV2 = {
  id?: UUID
  applicationName: string
  applicationId: string
  apiKey: string
  apiUrl: string
  privateKey: string
  signatureSecret: string
  smsNumbers?: VonageSmsNumberV2[]
  whatsappNumbers?: VonageWhatsAppNumberV2[]
}

export type VonageWhatsAppNumberV2<T = UUID> = {
  id?: number
  active?: boolean
  name: string
  number: string
  wabaId: string
  nameSpace: string
  space: T
  defaultSkill?: string
  vonageConfiguration?: VonageConfigurationDTOV2
}

export type VonageSmsNumberV2 = {
  id?: number
  name: string
  number: string
  space?: UUID
  notification: boolean
  conversational: boolean
  rcs: boolean
  defaultSkill?: string
  requiredSkills: number[]
  vonageConfiguration?: VonageConfigurationDTOV2
}

export enum VonageProtectedData {
  'wabaId' = 'wabaId',
  'nameSpace' = 'nameSpace',
}

export enum VonageApiUrl {
  DEFAULT = 'https://api-eu.vonage.com',
}
